import { FC, ReactNode } from 'react'
import { Collapse } from 'react-bootstrap'
import { ID } from '../../../../../../_metronic/helpers'
import { usePersistedCollapse } from '../hooks/usePersistedCollapse'
import styles from './styles/InformacoesAdicionaisBanner.module.css'
import { IconPaths, KTSVG } from '_metronic/helpers'

const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:)\]'"!?])/g

export const linkify = (texto: string): ReactNode[] =>
  texto.split(URL_REGEX).map((parte, index) =>
    index % 2 === 1 ? (
      <a
        key={index}
        href={parte}
        target='_blank'
        rel='noopener noreferrer'
        className='fw-semibold text-decoration-underline'
      >
        {parte}
      </a>
    ) : (
      parte
    )
  )

type InformacoesAdicionaisBannerProps = {
  instrucoes?: string[]
  atendimentoId?: ID
  className?: string
}

export const InformacoesAdicionaisBanner: FC<InformacoesAdicionaisBannerProps> = ({
  instrucoes,
  atendimentoId,
  className,
}) => {
  const storageKey =
    atendimentoId != null ? `atendimento-${atendimentoId}-info-adicionais-expandido` : null
  const { expanded, toggle } = usePersistedCollapse(storageKey)

  if (!instrucoes || instrucoes.length === 0) return null

  return (
    <div
      className={`rounded border border-warning bg-light-warning text-gray-900 py-3 px-4 ${
        className ?? ''
      }`}
    >
      <button
        type='button'
        className={`${
          styles.toggle
        } d-flex align-items-center gap-3 w-100 p-0 m-0 border-0 bg-transparent text-start text-gray-900 cursor-pointer ${
          expanded ? 'active' : ''
        }`}
        onClick={toggle}
        aria-expanded={expanded}
        aria-controls='informacoes-adicionais-conteudo'
      >
        <KTSVG
          path={IconPaths.Warning}
          className={`svg-icon-em fs-4 flex-shrink-0 ${styles.icone}`}
          ariaHidden
        />
        <span className='fs-9 fw-bold text-uppercase'>
          Informações adicionais <span>({instrucoes.length})</span>
        </span>
        <KTSVG
          path={IconPaths.ArrowDown}
          className='svg-icon-em rotate-180 ms-auto fs-8 flex-shrink-0 text-gray-700'
          ariaHidden
        />
      </button>

      <Collapse in={expanded}>
        <div id='informacoes-adicionais-conteudo'>
          <div className='pt-2 ps-10'>
            <ul className='ps-5 mb-0'>
              {instrucoes.map((item, index) => (
                <li
                  key={`${index}_instrucao`}
                  className='text-break fs-8 mb-1'
                  style={{ whiteSpace: 'pre-line' }}
                >
                  {linkify(item)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Collapse>
    </div>
  )
}
